// extracted by mini-css-extract-plugin
module.exports = {"root":"template-wrapper-module--root--2GZmd","section":"template-wrapper-module--section--7MYke","title":"template-wrapper-module--title--2XsTZ"};